import React from 'react'
import {createStore, applyMiddleware, compose, StoreEnhancer} from 'redux'
import {Provider} from 'react-redux'
import {routerMiddleware, ConnectedRouter} from 'connected-react-router'
import thunk from 'redux-thunk'
import {createBrowserHistory} from 'history'

import rootReducer from './reducers/index'

export const history = createBrowserHistory()

const initialState = {}
const enhancers: StoreEnhancer[] = []
const middleware = [thunk, routerMiddleware(history)]

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const {logger} = require('redux-logger')

  middleware.push(logger)
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers) as StoreEnhancer

const store = createStore(rootReducer(history), initialState, composedEnhancers)

const ProviderRedux: React.FC = ({children}) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>{children}</ConnectedRouter>
  </Provider>
)

export default ProviderRedux
